// utils
import { getSystemDefaultTheme } from 'utils/helpers/systemDefaultTheme';
// constants
import { THEME_KEYS } from 'modules/TradingChart/consts';
import { DARK_THEME_CSS_VARIABLES, LIGHT_THEME_CSS_VARIABLES } from './consts';

export const setBodyStyleBasedOnTheme = (theme: ThemeKeys) => {
  const body = window.document.querySelector('body');
    if (body) {
      const currentTheme = theme === 'auto'
        ? getSystemDefaultTheme()
        : THEME_KEYS[theme];
        if (currentTheme === 'dark') {
          Object.entries(DARK_THEME_CSS_VARIABLES).forEach(([key, value]) => {
            body.style.setProperty(key, value);
          });
        } else {
          Object.entries(LIGHT_THEME_CSS_VARIABLES).forEach(([key, value]) => {
            body.style.setProperty(key, value);
          });
        }
    }
};
